import AmexFranchiseEditorialsCard from './AmexFranchiseEditorialsCard';

export default AmexFranchiseEditorialsCard;
